<template>
  <div class="tableContent" id="manageUser" ref="tableContent"> 
    <el-form  :model="searchForm" class="searchFrom" ref="searchForm"  >
        <el-input v-model="searchForm.employee_id.value" placeholder="员工ID"  @keyup.enter.native="searchList" clearable maxlength="100"></el-input>
        <el-input v-model="searchForm.username.value" placeholder="姓名"  @keyup.enter.native="searchList" maxlength="100"></el-input>
        <el-select multiple collapse-tags filterable clearable v-model="searchForm.system.value" placeholder="系统" @focus="getSystemList" class="_select">
          <el-option :label="item.system_name" :value="item.system" v-for="item in systemList" :key="item.system_id" ></el-option>
        </el-select>
        <el-select multiple collapse-tags filterable clearable v-model="searchForm.menu_name.value" placeholder="菜单" @focus="getMenuList" class="_select">
          <el-option :label="item.label" :value="item.value" v-for="item in menuList" :key="item.value"></el-option>
        </el-select>
        <el-input v-model="searchForm.search.value" placeholder="查询条件"  @keyup.enter.native="searchList" maxlength="100"></el-input>
        <el-input v-model="searchForm.search_content.value" placeholder="查询内容"  @keyup.enter.native="searchList" maxlength="100"></el-input>
        <el-input v-model="searchForm.remark.value" placeholder="备注"  @keyup.enter.native="searchList" maxlength="100"></el-input>
        <el-input v-model="searchForm.create_name.value" placeholder="制单人"  @keyup.enter.native="searchList" maxlength="100"></el-input>
        <el-input v-model="searchForm.operator_name.value" placeholder="操作人"  @keyup.enter.native="searchList" maxlength="100"></el-input>
    </el-form>
    <div class="searchFormBtn">
      <div class="btnContainer" ref="btnContainer" >
         <button class="btn btn-add btn-edit" @click="addRow" v-if="$_has('/config_management/default_show/create')">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_add"></use>
          </svg>新增
        </button>
        <button class="btn btn-del" @click="delBtnBatch" v-if="$_has('/config_management/default_show/del')">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_delete"></use>
          </svg>删除
        </button>
        <button class="btn btn-info" @click="importBtn" v-if="$_has('/config_management/default_show/import')">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_import"></use>
          </svg>导入
        </button>
        <button class="btn btn-info" @click="exportBtn" v-if="$_has('/config_management/default_show/export')">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_export"></use>
          </svg>导出
        </button>
      </div>
      <div class="formBtnContainer">
        <span class="btn btn-add" @click="searchListClick">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_search"></use>
          </svg>
          <span>查询</span>
        </span>
        <span class="btn" @click="resetForm">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_rest"></use>
          </svg>
          <span>重置</span>
        </span>
      </div>
    </div>
    
    <div class="tableContainer"  v-if="$_has('/admin/list')">
      <el-table :data="tableList"  v-loading="loading" ref="tableList" 
      border :height="tableHeight" header-row-class-name="tableHeader" 
       @row-click="rowClick"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="48" align="center" fixed="left"></el-table-column>
        <el-table-column prop="employee_id" label="员工ID" width="178" align="center"></el-table-column>
        <el-table-column prop="username" label="姓名" width="178" align="center"></el-table-column>
        <el-table-column prop="system" label="系统" width="178" align="center"></el-table-column>
        <el-table-column prop="menu_name" label="菜单" width="228" align="center"></el-table-column>
        <el-table-column prop="search" label="查询条件" width="178" align="center"></el-table-column>
        <el-table-column prop="search_content" label="查询内容" width="178" align="center"></el-table-column>
        <el-table-column prop="remark" label="备注" width="178" align="center"></el-table-column>
        <el-table-column prop="create_name" label="制单人" width="178" align="center"></el-table-column>
        <el-table-column prop="create_time" label="制单时间" width="178" align="center"></el-table-column>
        <el-table-column prop="operator_name" label="操作人" width="178" align="center"></el-table-column>
        <el-table-column prop="operation_time" label="操作时间" width="178" align="center"></el-table-column>
        <el-table-column  label="操作" class-name='optionsCol' width="155" align="center" fixed="right">
          <template slot-scope="scope">
            <span @click.stop="showRowLog(scope)" class="textBtnEdit"  v-if="$_has('/config_management/default_show/log')">日志</span>
            <span @click.stop="editRow(scope.row.id)" class="textBtnEdit" v-if="$_has('/config_management/default_show/edit')">编辑</span>
            <span @click.stop="delBtnClick(scope)" class="textBtnDel" v-if="$_has('/config_management/default_show/del')">删除</span>
          </template>
        </el-table-column>
        <div slot="empty">
					<p>
						<img src="@/assets/img/noData.png" />
					</p>
					<p style="color:#030303;"><span>暂无相关数据</span></p>
				</div>
      </el-table>
    </div>
    <div style="position:relative;height:8vh;padding-top:20px;min-height:60px" ref="pagination">
        <div class="pagination" >
      <el-pagination  background @current-change="curPageChange" @size-change="sizeChange"
      :current-page="current_page" :page-sizes="page_sizes" :page-size="page_size" 
      :layout="total >= 6 ? 'prev, pager, next, total, sizes,  jumper':'pager, next, total, sizes,  jumper'"  
      :total="total">
      </el-pagination>
    </div> 
    </div>
 
    <UserOptions ref="userOpts" v-show="showUserOpts" :showUserOpts="showUserOpts" v-on:searchList="searchList" v-on:isShowUserOpts='isShowUserOpts'></UserOptions>
    <MessageBox ref="delRow" v-show="showDelMsgBox" v-on:success='delRow()' v-on:cancle='cancleDelRow()'></MessageBox>
    <UserLog ref="userLog" v-show="showLogDetail" :showLogDetail="showLogDetail" v-on:submit='isShowLogDetail()'></UserLog>
    <Import ref="import" :show="ImportShow" @closeDialog="isShowImport" @searchList="searchList"></Import>
    <Export ref="export" :show="ExportShow" @closeDialog="isShowExport"></Export>
  </div>
</template>

<script>
import MessageBox from '@/components/MessageBox'
import { defaultShowApi,systemListApi, del, menuListApi } from '@/api/manageConfig'
import { setSearchParams, appendStatus } from '@/utils/index'
import { UserOptions, UserLog } from './components'
import Export from './components/export.vue'
import Import from './components/import.vue'
export default {
  data(){
    return{
      departmentShow: false,
      department_one_id: '',
      department_two_id: '',
      searchForm:{
        employee_id:{value:'',op:'in'},//员工 ID
        username:{value:'',op:'in'},//姓名
        system:{value:'',op:'in'},//系统 
        menu_name:{value:'',op:'in'},//菜单 
        search:{value:'',op:'in'},//查询条件
        search_content:{value:'',op:'in'},//查询内容 
        remark:{value:'',op:'in'},//备注
        create_name: {value:'',op:'in'},//制单人 
        operator_name: {value:'',op:'in'},//操作人
      },
      total: 5,
      current_page: 1,
      page_sizes:[10, 25, 50, 1000],
      page_size:25,
      tableHeight: null,
      tableList:[],
      delList:[],
      curList:[],
      curIdList:[],

      systemList:[],
      system_res:[],
      menuList: [],
      ImportShow:false,
      ExportShow:false,

      showUserOpts:false,
      showDelMsgBox:false,
      selectList:[],
      showLogDetail:false,
      showRoleDetail:false,
      showCompanyDetail: false,
      loading:false
    }
  },
  created(){
    this.searchList()
  },
  mounted(){
    let that = this;
    that.setTableHeight()
    // 注：window.onresize只能在项目内触发1次
    window.onresize = function windowResize () {
        // 通过捕获系统的onresize事件触发我们需要执行的事件
      that.setTableHeight()
    }
  },
  components:{
    UserOptions,MessageBox,UserLog,Import,Export
  },
  methods:{
    getSystemList(){
      systemListApi().then(res=>{
        let system_api = res
        let system_filter = [...new Set(this.system_res)]
        let __system = []
        system_api.forEach(item => {
          system_filter.forEach(item2 => {
            if(item.system == item2){
              __system.push(item)
            }
          })
        })
        this.systemList = __system
      })
    },
    getMenuList () {
      let params = {
        system: JSON.stringify(this.searchForm.system.value)
        // system: this.searchForm.system.value
      }
      menuListApi(params).then(res=>{
        this.menuList = res
      })
    },
    importBtn(){
      this.isShowImport()
    },
    exportBtn(){
      this.isShowExport()
    },
    isShowImport(){
      this.ImportShow = !this.ImportShow
    },
    isShowExport(){
      this.ExportShow = !this.ExportShow
    },

    isShowRoleDetail(){
      this.showRoleDetail = !this.showRoleDetail
    },
    showRowLog(scope){
      this.$refs.userLog.id=scope.row.id
      this.isShowLogDetail()
    },
    isShowLogDetail(){
      this.showLogDetail = !this.showLogDetail
    },
    rowClick(row, column, event){
      this.$refs.tableList.toggleRowSelection(row);
    },
    delBtnClick(scope){
      let array = []
      array.push(scope.row.id)
      this.delList = array
      this.$refs.delRow.msg = {
        title:'确认删除',
        msg:'确认要删除此信息吗？',
        icon:'icon_delete_query'
      };
      this.isShowDelMsgBox()
    },
    delRow(){
      if(this.delList && this.delList.length>0){
        let delList = JSON.stringify(this.delList) 
        let params = {
          ids :delList
        }
        del(params).then(res=>{
          if(res.length==0){
            this.$message({message:'删除成功',type:'success'})
            this.searchList();
            this.cancleDelRow() 
          }
        })
      }else {
        this.$message({message:'请选中删除的选项',type:'error'})
      }
    },
    cancleDelRow () {
      this.delList=[]
      this.$refs.tableList.clearSelection()
      this.isShowDelMsgBox()
    },
    isShowDelMsgBox(){
      this.showDelMsgBox = !this.showDelMsgBox
    },
    isShowUserOpts(val){
      if(val == undefined){
        this.showUserOpts = !this.showUserOpts
      }else{
        this.showUserOpts = val
      }
    },
    resetForm(){
      let menuManage = this.searchForm
      for(let item in menuManage){
        menuManage[item].value =''
      }
      this.department_two_id = ''
      this.department_one_id = ''
      this.searchList()
    },
    searchListClick(){
      this.current_page = 1
      this.searchList()
    },
    searchList(){
      this.loading = true
      let params =  setSearchParams(this.searchForm,this.page_size,this.current_page)
      defaultShowApi(params).then(res=>{
        this.total = res.total
        this.tableList= appendStatus(res.data)
        this.loading = false
        // 拿表格列id
        let list = res.data
        let idList = []
        let _system_res = []
        for(let i = 0; i < list.length; i++){
          idList.push(list[i].id)
          _system_res.push(list[i].system)
        }
        this.curIdList = idList
        this.system_res = _system_res
      })
    },
    handleSelectionChange(list){
      let arr = new Array()
      for(let i in this.selectList){
        this.selectList[i].statusSelection = false
      }
      for (let item in list){
        arr.push(list[item].id)
        list[item].statusSelection = true
      }
      this.delList = arr
      this.curList = arr
    },
    setTableHeight(){
      let searchFormHeight = this.$refs.searchForm.$el.offsetHeight;
      let manageMenuHeight = this.$refs.tableContent.offsetHeight;
      let paginationHeight  = 0
      if(this.$refs.pagination){
         paginationHeight = this.$refs.pagination.offsetHeight + 30
      }
      let btnContainerHeight = 0
       if(this.$refs.btnContainer){
        btnContainerHeight = this.$refs.btnContainer.offsetHeight 
      }
      let tableHeight = manageMenuHeight  - searchFormHeight - paginationHeight -btnContainerHeight
      this.tableHeight = tableHeight +'px'
    },
    addRow(){
      this.$refs.userOpts.isAdd = true
      this.$refs.userOpts.id=""
      this.isShowUserOpts()
    },
    editRow(id){
      this.$refs.userOpts.isAdd = false;
      this.$refs.userOpts.id = id
      this.isShowUserOpts()        
    },
    // 编辑按钮
    editBtnBatch(){
      if(this.delList && this.delList.length == 1){
        this.editRow(this.delList[0])
      }
    },
     // 批量删除
    delBtnBatch(){
     if(this.delList && this.delList.length>0){
        this.$refs.delRow.msg = {
          title:'确认删除',
          msg:'确认要删除此信息吗？',
          icon:'icon_delete_query'
        };
        this.isShowDelMsgBox()
      }else {
        this.$message({message:'请选中删除的选项',type:'error'})
      }
    },
    curPageChange(value){
      this.current_page = value;
      this.searchList()
    },
    sizeChange(value){
      this.page_size = value;
      this.searchList()
    }
  }

}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';

#manageUser{
  .formBtnContainer{
    top: 61px;
  }
 
  .buleText{color: $btn-search;font-size: 14px;cursor: pointer;}
  .textBtnEdit{
    border-right: 1px solid #E9EDF0;
  }
  
}
._select{
  .el-tag.el-tag--info{
    max-width: 120px;
    overflow: hidden;
  }
}
</style>